import { VeloCacheHitContext, NavigationDrawer } from 'velo-react-components';

export function PaymentMethodsCacheHitConsumer({ children }) {
  const [cacheValue, increment] = VeloCacheHitContext.useVeloCacheHitContext(
    NavigationDrawer.Items.CHANNELS
  );
  return children(increment, cacheValue);
}
